export var domElementGetter = domElement => {
  var element = document.getElementById(domElement);

  if (!element) {
    element = document.createElement('div');
    element.id = domElement;
    document.body.appendChild(element);
  }

  return element;
};
//# sourceMappingURL=index.js.map